import Symbol from "./Symbol";
import { INSPECTOR_ELECTRODUCTS } from "../../../constants/inspectorConstants";

class DistributionLine extends Symbol {
    constructor({ alias, svgSrc, label, rotable, handles, name}) {
        super("DistributionLine", { alias, svgSrc, label, rotable, handles, name });

        this.attributes = {
            ...this.attributes,
            height: { isVisible: false, value: null, label: "Alto" },
            length: { isVisible: false, value: null, label: "Longitud" },
            lineSpacing: { isVisible: false, value: null, label: "Separación entre Líneas" },
            cableGauge: { isVisible: false, value: null, label: "Calibre de Cable" },
            cableType: { isVisible: false, value: null, label: "Tipo de Cable" },
        };                
    }

    getInspector() {
        return INSPECTOR_ELECTRODUCTS;
    }
}

export default DistributionLine;
